<template>
  <div class="unit_test_wrap">
    <div class="unit_test_title">
      <span style="margin-left:24px">我的得分：<b>{{unitScore}}</b>分</span>
      <i> - </i>
      <span>单元测试成绩=单元测验平均分*单元测验权重</span>
    </div>
    <el-table
      border
      ref="multipleTable"
      :data="treeData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: '#E8F2FF', color: '#606266' }"
      :cell-style="changeCellStyle"
      class="unit_test_table"
    >
      <el-table-column label="章节" align="center">
        <template slot-scope="scope"><div style="text-align: left; margin-left:40px">NO.{{scope.$index+1}} {{ scope.row.parentCataLog }}</div></template>
      </el-table-column>
      <el-table-column label="测验名称" align="center">
        <template slot-scope="scope"><div style="text-align: left; margin-left:40px;">{{ scope.row.paperName }}</div></template>
      </el-table-column>
      <el-table-column label="得分" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.score||scope.row.score==0"><span style="color:#5397F7">{{scope.row.score}}分</span></div>
          <div v-else style="display: flex;align-items:center;justify-content: center;">
            <img src="../../../../../../../static/images/sourceIcon/weikaishi.png" alt="" style="width: 16px;">
            <span style="color:#FF785A;margin-left: 3px">未开始</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as api from "../../../../../../api/achievementApi";
export default {
  props: [ 'courseId', 'userId', 'classId' ],
  data() {
    return {
      treeData: [],
      unitScore: '',
    }
  },
  mounted() {
    this.getDetailsData()
  },
  methods: {
    getDetailsData(){
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
        classId:this.classId
      }
      api.getAchievementTestList(obj).then(rs=>{
         if(rs.code==0){
          this.unitScore = Number(rs.data.unitScore)
          this.treeData = rs.data.courseExamDetailResps
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if(row.columnIndex === 1){
          return 'background: rgba(83,151,247,0.05)'
      }else{
          return ''
      }
    }
  },
}
</script>
<style lang="scss">
  .unit_test_wrap{
    .unit_test_title{
      height:40px;
      border:1px solid rgba(226,226,226,1);
      border-radius:4px;
      display: flex;
      align-items: center;
      span{
        font-size: 12px;
        color: #333;
        b{
          font-weight: 400;
          color: #5397f7;
        }
      }
      i{
        margin: 0 5px;
      }
    }
    .unit_test_table{
      margin: 16px 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/achievement/student/unitTest.vue